import {JSX} from "react";

import {InfoCard, InfoCardProps} from "@/shared/ui/data-display/cards";
import {Typography} from "@/shared/ui/data-display/typography";
import {SpinnerOverlay} from "@/shared/ui/feedback/spinner-overlay";

interface PopularPostsContentProps {
    isLoading: boolean;
    visiblePosts: ReadonlyArray<InfoCardProps>;
    noResultsText: string;
}

export function PopularPostsContent({isLoading, visiblePosts, noResultsText}: PopularPostsContentProps): JSX.Element {
    const hasPosts = visiblePosts.length > 0;

    return (
        <div className="popular-posts__content-wrapper" style={{minHeight: isLoading ? "200px" : "auto"}}>
            <SpinnerOverlay loading={isLoading} size="large" variant="container" />
            {!isLoading && !hasPosts ? (
                <div className="popular-posts__no-results">
                    <Typography as="p" size={{desktop: 18, mobile: 16}} color="paragraph">
                        {noResultsText}
                    </Typography>
                </div>
            ) : (
                <div className="popular-posts__cards" style={{opacity: isLoading ? 0.5 : 1, transition: "opacity 0.2s"}}>
                    {visiblePosts.map((post) => (
                        <InfoCard key={post.id} {...post} />
                    ))}
                </div>
            )}
        </div>
    );
}
